"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/www/xmg-cms-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _router = _interopRequireDefault(require("./router"));

var _store = _interopRequireDefault(require("./store"));

var _elementUi = require("element-ui");

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/utils/auth");

var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));

// progress bar
// progress bar style
// get token from cookie
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration


var whiteList = ['/login']; // no redirect whitelist

_router.default.beforeEach(
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasGetUserInfo;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start(); // set page title


            document.title = (0, _getPageTitle.default)(to.meta.title); // determine whether the user has logged in

            hasToken = (0, _auth.getToken)();

            if (!hasToken) {
              _context.next = 29;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            });

            _nprogress.default.done();

            _context.next = 27;
            break;

          case 9:
            hasGetUserInfo = _store.default.getters.name;

            if (!hasGetUserInfo) {
              _context.next = 14;
              break;
            }

            next();
            _context.next = 27;
            break;

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return _store.default.dispatch('user/getInfo');

          case 17:
            next();
            _context.next = 27;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](14);
            _context.next = 24;
            return _store.default.dispatch('user/resetToken');

          case 24:
            _elementUi.Message.error(_context.t0 || 'Has Error');

            next("/login?redirect=".concat(to.path));

            _nprogress.default.done();

          case 27:
            _context.next = 30;
            break;

          case 29:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));

              _nprogress.default.done();
            }

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 20]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});